import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import Answers from './Answers';
import FormDateField from '../legacyForm/FormDateField';
import VoterIdentificationMethods from './VoterIdentificationMethods';
import { validateAnswers } from '../../models/budget/budgetSubmissionValidation';

const selector = formValueSelector('budgetVoteForm');

let BudgetVoteForm = ({
  handleSubmit,
  submitting,
  votingSettings,
  disabled,
  change,
  error,
  voterData,
  voterIdentificationMethodId,
  actions }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Dodawanie głosu w wersji papierowej</h2>
            </div>
          </div>
        </div>
        <Answers votingSettings={votingSettings} error={error} />
      </div>

      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Dane osoby głosującej</h2>
            </div>
          </div>
        </div>
        <div className="box">
          <div className="col-sm-12">
            <VoterIdentificationMethods
              voterIdentificationMethods={votingSettings.voterIdentificationMethods}
              change={change}
              voterIdentificationMethodId={voterIdentificationMethodId}
              actions={actions}
              voterData={voterData}
              manualVote
              autocomplete
              customMessages={votingSettings.customMessages || {}}
              budgetId={votingSettings.budgetId}
            />
            <div style={{ marginTop: 16 }}>
              <Field
                name="submissionDate"
                component={FormDateField}
                label="Data oddania głosu"
                minDate={votingSettings.votingStartDate}
                maxDate={votingSettings.votingEndDate}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12" style={{ marginRight: 15 }}>
          <button type="submit" disabled={submitting || disabled} className="btn btn-send">
            {submitting ? 'Zapisywanie...' : 'Zapisz głos'} <i className="fa fa-paper-plane" />
          </button>
        </div>
      </div>
    </form>
  );
};

BudgetVoteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  details: PropTypes.array,
  votingSettings: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  actions: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  voterData: PropTypes.object,
  voterIdentificationMethodId: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    details: selector(state, 'details'),
    voterData: selector(state, 'voter'),
    voterIdentificationMethodId: selector(state, 'voterIdentificationMethodId'),
  };
}

BudgetVoteForm = reduxForm({
  form: 'budgetVoteForm',
  enableReinitialize: true,
  validate: validateAnswers,
})(BudgetVoteForm);

export default connect(mapStateToProps)(BudgetVoteForm);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetManualVoteForm.js